var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93744 1.53769C9.92201 0.553123 11.2574 0 12.6498 0H22.3503C23.7426 0 25.078 0.553123 26.0626 1.53769L33.4623 8.93744C34.4468 9.92201 35 11.2574 35 12.6498V22.3503C35 23.7426 34.4468 25.078 33.4623 26.0626L26.0626 33.4623C25.078 34.4468 23.7426 35 22.3503 35H12.6498C11.2574 35 9.92201 34.4468 8.93744 33.4623L1.53769 26.0626C0.553123 25.078 0 23.7426 0 22.3503V12.6498C0 11.2574 0.553123 9.92201 1.53769 8.93744L8.93744 1.53769ZM19.25 10.5C19.25 9.53351 18.4665 8.75 17.5 8.75C16.5335 8.75 15.75 9.53351 15.75 10.5V19.25C15.75 20.2165 16.5335 21 17.5 21C18.4665 21 19.25 20.2165 19.25 19.25V10.5ZM19.25 24.4804C19.25 23.5139 18.4665 22.7304 17.5 22.7304C16.5335 22.7304 15.75 23.5139 15.75 24.4804V24.5C15.75 25.4665 16.5335 26.25 17.5 26.25C18.4665 26.25 19.25 25.4665 19.25 24.5V24.4804Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritical);
export default __webpack_public_path__ + "static/media/critical.a25251e6d733c67b292f4aa12a439c3f.svg";
export { ForwardRef as ReactComponent };